import Component from "flarum/Component";
import app from "flarum/app";
import LoadingIndicator from "flarum/components/LoadingIndicator";
import Button from "flarum/components/Button";
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';

import DecorationStoreEquipmentStatusModal from "./DecorationStoreEquipmentStatusModal";
import DecorationStoreEquipmentListModal from "./DecorationStoreEquipmentListModal";
import navigationOptionDropdown from "../common/util/navigationOptionDropdown";

export default class DecorationStoreEquipmentIndexPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.equipmentList = [];
    this.equipmentSlotList = [];

    const itemTypeList = app.forum.attribute("decorationStoreItemTypes");

    for(let index in itemTypeList){
      const itemTypeValue = itemTypeList[index];
      this.equipmentSlotList.push({id:itemTypeValue,text:app.translator.trans("ziven-decoration-store.lib.item-type-"+itemTypeValue)});
    }

    this.loadResults();
  }

  view() {
    let loading;
    let itemCount = 0;
    this.equipmentData = {};

    if(this.loading){
      loading = LoadingIndicator.component({ size: "large" });
    }

    for(let index in app.store.data.decorationStoreEquipment){
      const equipmentData = app.store.data.decorationStoreEquipment[index];
      const itemData = equipmentData.decorationData();
      const itemType = itemData.item_type();
      
      this.equipmentData[itemType] = equipmentData;
    }

    return (
      <div>
        <div className="DecorationPageHeaderContainer">
          <div>
            {navigationOptionDropdown("item1")}
          </div>
        </div>

        {!loading && (
          <div className="DecorationStoreEquipmentContainer">
            <div className="DecorationEquipmentFlexCard">
              {this.equipmentSlotList.map((slotData) => {
                const slotID = slotData.id;
                const slotText = slotData.text;
                const itemPurchaseData = this.equipmentData[slotID] || null;
                let purchaseStatus = 0;
                let purchaseID = -1;
                let itemPropertyImage = "";
                let itemPurchaseTypeText = "";
                let itemType = "";

                if(itemPurchaseData!==null){
                  const itemData = itemPurchaseData.decorationData();
                  const itemProperty = JSON.parse(itemData.item_property());
                  let itemPurchaseType = itemPurchaseData.purchase_type();
                  itemPropertyImage = itemProperty.image;
                  purchaseStatus = itemPurchaseData.item_status();
                  purchaseID = itemPurchaseData.id();
                  itemType = itemData.item_type();

                  if(itemPurchaseType!=="onetime"){
                    itemPurchaseTypeText = app.translator.trans("ziven-decoration-store.lib.item-purchase-type-"+itemPurchaseType);
                  }
                }

                const slotClassName = "DecorationStoreEquipmentSlot "+(itemPropertyImage===""?"DecorationStoreEquipmentUnselected":"DecorationStoreEquipmentSelected")
                const slotNameClassName = "DecorationStoreEquipmentName "+(itemPropertyImage===""?"DecorationStoreEquipmentNameUnselected":"DecorationStoreEquipmentNameSelected");

                let itemImageStyle = "";
                if(itemType==="profileBackground"){
                  itemImageStyle = "background-image:url("+itemPropertyImage+")";
                }

                let itemClass = "DecorationEquipmentCardsListItem DecorationEquipmentCard";

                if(itemCount%3!==0){
                  itemClass+=" DecorationItemCardAdjust";
                }

                itemCount++;

                return (
                  <div className={itemClass}>
                    <div className={slotClassName}>
                      <div className={slotNameClassName}>
                        {slotText}
                      </div>

                      {purchaseStatus===0 && (
                        <div className="DecorationStoreEquipmentImage">
                          <span className="Avatar DecorationStoreEquipmentSlotIcon" onclick={() => this.showPruchaseItemList(slotID)}><i aria-hidden="true" class="icon fas fa-plus "></i></span>
                        </div>
                      )}

                      {purchaseStatus===1 && (
                        <div className="DecorationStoreEquipmentImage">
                          <div className="DecorationStoreEquipmentSlotRemove" onclick={() => this.setItemStatus(itemPurchaseData,0)}><i aria-hidden="true" class="icon fas fa-times-circle "></i></div>
                          <div className="DecorationStoreEquipmentSlotPurchaseType">{itemPurchaseTypeText}</div>
                          
                          {itemType==="avatarFrame" && (
                            <img style="height:130px" src={itemPropertyImage}  onclick={() => this.showPruchaseItemList(slotID)}/>
                          )}
                          {itemType==="profileBackground" && (
                            <div className="DecorationEquipmentIndexProfileBackgroundImage" style={itemImageStyle}  onclick={() => this.showPruchaseItemList(slotID)}></div>
                          )}
                          {itemType==="usernameColor" && (
                            <div className="DecorationEquipmentIndexUsernameColor" onclick={() => this.showPruchaseItemList(slotID)}>
                              <div className={itemPropertyImage}>{app.translator.trans("ziven-decoration-store.forum.item-property-style-text-effect")}</div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
        )}

        {loading && <div className="DecorationStore-loadMore">{loading}</div>}
      </div>
    );
  }

  setItemStatus(itemPurchaseData,purchaseStatus){
    app.modal.show(DecorationStoreEquipmentStatusModal, {itemPurchaseData,purchaseStatus});
  }

  showDecorationStore(){
    m.route.set(app.route("decorationStore"));
  }

  showPruchaseItemList(itemType){
    app.modal.show(DecorationStoreEquipmentListModal,{itemType});
  }

  parseResults(results) {
    [].push.apply(this.equipmentList, results);

    this.loading = false;
    m.redraw();
  }

  loadResults() {
    return app.store
      .find("decorationStoreEquipment")
      .catch(() => {})
      .then(this.parseResults.bind(this));
  }
}
